<template>
  <div class="course_container-warp">
    <SearchInput descPlaceHolder="请输入关键词" path="/search" />
    <router-view></router-view>
    <cartoon-kid :homeUserInfo="userInfo"></cartoon-kid>
  </div>
</template>

<script>
// import { registerWxConfig } from '@/weixinConfig.js'
// registerWxConfig()
import SearchInput from "@/views/index/components/search-input.vue";
import { getHealthArchivesByLoginUser } from "./../api/test-center";
import { verticalScreen } from "../assets/js/vertical-screen";
import { decryptBy, encryptBy } from "@/assets/js/encryption";
import { _queryArchives, _bindParentFlag } from "./../api/family-archives";
import CartoonKid from "@/views/cartoon-kid/index.vue";
import { Toast } from "vant";
import store from "../store/index.js";
import router from "@/router";
export default {
  name: "course",
  components: {
    SearchInput,
    CartoonKid,
  },
  props: {},
  data() {
    return {
      childInfo: "",
      userInfo: {},
      parentCount: 0, //家长的数量
      childTotal: 0, //所有儿童的总数量
      totalNum: 0, //总问券数量
    };
  },
  watch: {},
  computed: {},
  methods: {
    //根据登录用户获取是否绑定家长信息 (true 已绑定,false未绑定)
    bindParentFlag() {
      _bindParentFlag().then((res) => {
        if (res.code == 200) {
          if (!res.data) {
            this.$router.replace("/basicInfor");
          }
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 查询家长信息
    queryArchives() {
      _queryArchives().then((res) => {
        if (res.code == 200) {
          this.userInfo = res.data;
          localStorage.setItem(
            "parentsInfor",
            encryptBy(JSON.stringify(res.data))
          );
        } else {
          this.$toast(res.message);
        }
      });
    },
  },
  // async beforeRouteEnter(to, from, next) {
  //   const res = await store.dispatch('children')
  //   if (!res.data) {
  //     router.replace("/identity");
  //   } else {
  //     next()
  //   }
  // },
  async beforeRouteEnter(to, from, next) {
    let info = localStorage.getItem("userInfo");
    if (info) {
      let user = JSON.parse(decryptBy(info));
      if (user.userType == "PARENT") {
        const res = await store.dispatch("children");
        if (!res.data) {
          router.replace("/identity");
        } else {
          next();
        }
      } else {
        next();
      }
    }
  },

  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    verticalScreen();
  },
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss" scoped>
$bgheader: "../assets/images/parent-course/header-bg.png";
$tiptext: "../assets/images/parent-course/tiparrow.png";
.course_container-warp {
  min-height: 100vh;
  background: url("../assets/images/index/header-bg.png") no-repeat;
  background-size: 100%;
  background-position-y: -84px;
  padding-top: 8px;
  background-color: #f5f7fa;
  // .header {
  //   width: 100%;
  //   height: 256px;
  //   // border: 1px solid red;
  //   background: url($bgheader) no-repeat;
  //   background-size: cover;
  //   .top-part {
  //     position: relative;
  //     display: flex;
  //     justify-content: center;
  //     .header-title {
  //       display: inline-block;
  //       height: 25px;
  //       font-size: 18px;
  //       color: #fff;
  //       line-height: 25px;
  //       text-align: center;
  //       margin-top: 29px;
  //       margin-bottom: 14px;
  //     }
  //     .cartoon {
  //       position: absolute;
  //       right: 0;
  //       top: 7px;
  //       img {
  //         width: 57px;
  //         height: 57px;
  //       }
  //     }
  //     .tip-text {
  //       position: absolute;
  //       right: 58px;
  //       top: 19px;
  //       width: 82px;
  //       height: 40px;
  //       font-size: 10px;
  //       font-weight: 500;
  //       color: #ff7c1f;
  //       line-height: 17px;
  //       background-size: contain;
  //     }
  //   }
  // }
}
</style>
